/* ------------------------------------------------------------------------
   Fetches this section's own re-render from Shopify's product
   recommendations endpoint (routes.product_recommendations_url) and swaps
   it in — the standard pattern for this API: the section can only see
   real recommendations when requested with &product_id=, so a normal
   page load renders empty and this fills it in once.
   ------------------------------------------------------------------------ */
(function () {
	document.querySelectorAll('[data-kc-recs]').forEach(function (section) {
		var url = section.getAttribute('data-url');
		if (!url) return;

		fetch(url)
			.then(function (response) { return response.text(); })
			.then(function (html) {
				var doc = new DOMParser().parseFromString(html, 'text/html');
				var inner = doc.querySelector('.kc-recs__inner');
				if (inner) section.appendChild(inner);
			})
			.catch(function (err) {
				window.console && console.error && console.error('kc product recommendations fetch failed', err);
			});
	});
})();
